/**
 * Password-manager opt-out props.
 *
 * Spread onto every <input> and <textarea> in the app so that browser
 * password managers (1Password, LastPass, Bitwarden, Dashlane, etc.)
 * don't try to auto-fill meeting titles / locations / project names /
 * email subjects with the user's saved credentials. The app uses
 * Microsoft SSO — there is no username / password field anywhere in the
 * product — so blanket suppression is safe.
 *
 * Each manager has its own opt-out hint; we include all of them because
 * the cost is zero and browser heuristics keep shifting. The
 * autoComplete='off' handles the native browser autofill bucket;
 * data-1p-ignore, data-lpignore, data-bwignore target specific
 * extensions; data-form-type='other' tells Dashlane "don't treat this
 * form as a login form."
 *
 * Usage:
 *
 *   <input {...NO_AUTOFILL} type="text" value={x} onChange={...} />
 *
 * Any prop you set to the right of the spread wins over the defaults
 * here (React merges left-to-right). If you need a specific
 * autoComplete behavior for a field — e.g. a legitimate email input
 * where you DO want Outlook's address-book autocomplete — override
 * autoComplete after the spread.
 */
export const NO_AUTOFILL = {
  autoComplete: 'off',
  'data-1p-ignore': true,
  'data-lpignore': 'true',
  'data-bwignore': true,
  'data-form-type': 'other',
} as const;
